import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface CustomerDataRefreshEvent {
  customerId?: string;
  source: string;
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class CustomerDataRefreshService {
  private refreshSubject = new Subject<CustomerDataRefreshEvent>();
  
  public refresh$: Observable<CustomerDataRefreshEvent> = this.refreshSubject.asObservable();

  triggerRefresh(source: string, customerId?: string): void {
    const event: CustomerDataRefreshEvent = {
      customerId: customerId || sessionStorage.getItem('CustomerId') || undefined,
      source,
      timestamp: Date.now()
    };
    console.log(`[CustomerDataRefresh] Refresh triggered from: ${source}`, event);
    this.refreshSubject.next(event);
  }
}
